// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"d6ad4e69","409":"74cf23ce","650":"58ff28bd","790":"74cf23ce"}[chunkId] + ".chunk.js";
};